import { Card, Col, Row, Select, Typography } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import moment from 'moment';
import React, { useState } from 'react'
import { useGetCryptosQuery } from '../services/cryptoApi';
import { useGetCryptoNewsQuery } from '../services/cryptoNewsApi';
import Loader from './Loader';

const { Text, Title } = Typography
const { Option } = Select
const demoImage = 'https://coinrevolution.com/wp-content/uploads/2020/06/cryptonews.jpg'
function News({ simplified }) {
  const [newsCategory, setNewsCategory] = useState('Cryptocurrency')
  const { data: cryptoNews } = useGetCryptoNewsQuery({ newsCategory: `${newsCategory} currency`, count: simplified ? 6 : 12 });
  const { data: cryptosList, isFetching } = useGetCryptosQuery(100);

  if (!cryptoNews?.value) return <Loader />
  
  return (
    <>
      <Row gutter={[24, 24]}>
        {!simplified && <Col span={24}>
          <Select showSearch className='select-news' placeholder='Select a Crypto' optionFilterProp='childern' onChange={(value) => setNewsCategory(value)} filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
            <Option value='Cryptocurrency'>Cryptocurrency</Option>
            {cryptosList?.data?.coins?.map((coin) => <Option value={coin.name} key={coin.uuid}>{coin.name}</Option>)}
          </Select>
        </Col>
        }
        {cryptoNews?.value?.map((news, i) => (
          <Col xs={24} sm={12} lg={8} key={i}>
            <Card hoverable className='news-card'>
              <a href={news.url} target='_blank' rel='noreferrer'>
                <div className="news-image-container">
                  <Title className='news-title line-clamp-3' level={4}>
                    {news.name}
                  </Title>
                  <img style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'cover' }} src={news?.image?.thumbnail?.contentUrl || demoImage} alt="" />
                </div>
                  <p>{news.description > 100 ? `${news.description.substring(0, 100)}...` : news.description}</p>
                  <div className='provider-container'>
                    <div>
                      <Avatar src={news.provider[0]?.image?.thumbnail?.contentUrl || demoImage} alt="" />
                      <Text className='provider-name'>{news.provider[0]?.name}</Text>
                    </div>
                    <Text>{moment(news.datePublished).startOf('ss').fromNow()}</Text>
                  </div>
              </a>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  )
}

export default News